/**
 * MSW Overrides: Booking Features scenario
 *
 * Returns a mocked response for GET /bookings/features while the real endpoint
 * is not yet available, allowing booking configuration flag behaviour to be tested
 * end-to-end in local development.
 *
 * Enable by setting ENABLE_MSW=true and NUXT_PUBLIC_MSW_OVERRIDES_BOOKING_FEATURES=true
 * in your .env, then restart the dev server.
 */

import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';

export const MOCK_BOOKING_FEATURES = {
  features: {
    connectingFlights: { enabled: true },
    oneTimePurchaseAncillaries: { enabled: false },
    quotaBreakdown: { enabled: true },
    subscriptionAncillaries: { enabled: true },
  },
};

export function createBookingFeaturesOverrides(baseUrl: string) {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.get(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.BOOKING_FEATURES)}`,
      () => HttpResponse.json(MOCK_BOOKING_FEATURES),
    ),
  ];
}

